import { LayoutProvider } from 'core/contexts/layout';
import { AuthProvider } from 'core/contexts/auth';
import { TripsProvider } from 'core/contexts/trips';
import { ModusesProvider } from 'core/contexts/modus';
import { LocationsProvider } from 'core/contexts/location';
import { CoTripersProvider } from 'core/contexts/coTriper';
import { ExperiencersProvider } from 'core/contexts/experiencer';
import { UnitsProvider } from 'core/contexts/units';
import { TripersProvider } from 'core/contexts/triper';
import { ExperiencesProvider } from 'core/contexts/experience';
import { ScheduleProvider } from 'core/contexts/schedule';
import { BookingProvider } from 'core/contexts/booking';
import { CurrencyProvider } from 'core/contexts/currency';
import { PaymentProvider } from 'core/contexts/payment';
import { StripeProvider } from 'core/contexts/stripe';
import { RefreshTokenProvider } from 'core/contexts/refreshToken';
import { ExperienceDetailProvider } from 'core/contexts/experienceDetail';
import { PriceGroupTabProvider } from 'core/contexts/priceGroupTab';
import { PriceGroupProvider } from 'core/contexts/priceGroup';
import { UnitLinksProvider } from 'core/contexts/unitLinks';
import { ReportProvider } from 'core/contexts/reports';

// V2
import { ExperiencesProviderV2 } from 'core/contexts/experienceV2';
import { ExperienceWizardProvider } from 'core/contexts/experienceWizard';
import { BookingProviderV2 } from 'core/contexts/bookingV2';

const AppProvider = ({ children }) => {
    return (
        <LayoutProvider>
            <AuthProvider>
                <StripeProvider>
                    <CurrencyProvider>
                        <TripsProvider>
                            <ModusesProvider>
                                <LocationsProvider>
                                    <CoTripersProvider>
                                        <ExperiencersProvider>
                                            <TripersProvider>
                                                <ExperiencesProvider>
                                                    <ExperienceDetailProvider>
                                                        <ScheduleProvider>
                                                            <RefreshTokenProvider>
                                                                <BookingProvider>
                                                                    <PaymentProvider>
                                                                        <ReportProvider>
                                                                            <PriceGroupTabProvider>
                                                                                <PriceGroupProvider>
                                                                                    <UnitsProvider>
                                                                                        <ExperiencesProviderV2>
                                                                                            <ExperienceWizardProvider>
                                                                                                <BookingProviderV2>
                                                                                                    <UnitLinksProvider>{children}</UnitLinksProvider>
                                                                                                </BookingProviderV2>
                                                                                            </ExperienceWizardProvider>
                                                                                        </ExperiencesProviderV2>
                                                                                    </UnitsProvider>
                                                                                </PriceGroupProvider>
                                                                            </PriceGroupTabProvider>
                                                                        </ReportProvider>
                                                                    </PaymentProvider>
                                                                </BookingProvider>
                                                            </RefreshTokenProvider>
                                                        </ScheduleProvider>
                                                    </ExperienceDetailProvider>
                                                </ExperiencesProvider>
                                            </TripersProvider>
                                        </ExperiencersProvider>
                                    </CoTripersProvider>
                                </LocationsProvider>
                            </ModusesProvider>
                        </TripsProvider>
                    </CurrencyProvider>
                </StripeProvider>
            </AuthProvider>
        </LayoutProvider>
    );
};

export default AppProvider;
